module.exports = __webpack_public_path__ + "static/media/andy.662547ea.png";